export { Bee404Module } from './bee-404.module';
export { Bee404Component } from './bee-404.component';
